import { APICallV2Post } from '../APICall';

export class PublishFileApiCall extends APICallV2Post {
    _method = 'file/publish';
}
